export default {
  routes: [
    {
      name: 'issues',
      path: '/directory/support',
      component: () => import('./views/TheIssues.vue'),

    },

    {
      name: 'issue',
      path: '/directory/support/:uuid',
      component: () => import('./views/TheIssue.vue'),
    },
  ]
}
